import { create } from "zustand";

const readStoredDarkMode = () => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("isDark") === "true";
};

const useThemeStore = create((set) => ({
  isDark: readStoredDarkMode(),
  setIsDark: (isDark) => set({ isDark: Boolean(isDark) }),
}));

export default useThemeStore;
